import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Let AuthContext / ProtectedRoute handle redirects
    }
    return Promise.reject(err);
  }
);

// Pass the full response body as `data` to also read NestJS errors, which use
// `message` rather than `detail`. Existing single-argument callers are unaffected.
export function formatApiError(detail, data) {
  const resolved = detail ?? data?.message ?? data?.detail;
  if (resolved == null) return 'Something went wrong. Please try again.';
  if (typeof resolved === 'string') return resolved;
  if (Array.isArray(resolved)) {
    return resolved
      .map((e) => (typeof e === 'string' ? e : e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(', ');
  }
  if (resolved && typeof resolved.msg === 'string') return resolved.msg;
  return String(resolved);
}

export default api;
